import { getMenuTree } from '@/api/system/menu'

const state = {
  menus: []
}

const mutations = {
  SET_MENUS: (state, menus) => {
    state.menus = menus
  }
}

const actions = {
  // 获取菜单
  getMenus({ commit }) {
    return new Promise((resolve, reject) => {
      getMenuTree().then(response => {
        //console.log('-----获得菜单-----')
        //console.log(response)
        
        commit('SET_MENUS', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  // 设置菜单
  setMenus({ commit }, menus) {
    commit('SET_MENUS', menus)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}